import { type, Entity, validatedResource, association, resource, repository } from 'aurelia-orm';
import { InviteRepository } from 'data/repository/invite-repository';
import { HelpTopicPreferenceRepository } from 'data/repository/help-topic-preference-repository';

@resource("help-topic-preference")
	@repository(HelpTopicPreferenceRepository)
export class HelpTopicPreference extends Entity {
	id: number;
	helpItemId: number;
	appUserId: number;
	show: boolean;
}